/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
/// <reference path="../../../../Scripts/typings/durandal/durandal.d.ts" />
/// <reference path="../../../../Scripts/typings/knockout.es5/knockout.es5.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/organizationmanager/viewmodels/index',["require", "exports", "durandal/app", "models/breeze", "common/string", "common/commands", "common/constants", "services/httpclient", "services/trace", "services/navigator", "areas/organizationmanager/commands/showuserdatacommand", "areas/organizationmanager/commands/resendactivationcommand", "areas/organizationmanager/commands/createinfrastructurecommand", "areas/organizationmanager/commands/directloginorgcommand", "areas/organizationmanager/commands/downloadorgpdfcommand", "areas/organizationmanager/services/organizationsrepository", "areas/organizationmanager/models/organizationbase", "areas/organizationmanager/services/mappings"], function (require, exports, app, Data, String, Commanding, Constants, HttpClient, Trace, Navigator, ShowUserDataCommand, ResendActivationCommand, CreateInfrastructureCommand, DirectLoginOrgCommand, DownloadOrgPdfCommand, repository, organization, mappings) {
    "use strict";
    var IndexViewModel = (function (_super) {
        __extends(IndexViewModel, _super);
        //#endregion
        // #region ctor
        function IndexViewModel() {
            _super.call(this);
            this.showAccountant = false;
            this.organizations = new repository.OrganizationRepository();
            this.filterHandlers = new Array();
            this.greaterThan10Members = false;
            this.searched = false;
            ko.track(this, ['organizationFilter', 'searched', 'greaterThan10Members', 'showAccountant']);
        }
        // #endregion
        //#region override
        IndexViewModel.prototype.onActivated = function (context) {
            _super.prototype.onActivated.call(this, context);
            this.initialize(context);
        };
        //#endregion
        //#region validateUserActions
        IndexViewModel.prototype.isSelectedOrganizationStb = function () {
            if (this.selectedItems().length == 1 && Constants.OrganizationTypes.Stb == this.selectedItems()[0].organizationType) {
                return true;
            }
            return false;
        };
        //#endregion
        //#region state
        IndexViewModel.prototype.showClientLink = function (currentOrganization) {
            if (currentOrganization.organizationType.toLowerCase() == Constants.OrganizationTypes.Stb.toLowerCase() &&
                currentOrganization.countClientsOrTaxConsultant != "0") {
                return true;
            }
            return false;
        };
        //#endregion
        //#region navigation
        IndexViewModel.prototype.goBack = function () {
            this.getOrganizations();
        };
        IndexViewModel.prototype.getOrganizations = function () {
            var _this = this;
            this.detachFilterHandlers();
            this.controller.override("findbynameanduri");
            if (!String.isNullOrEmpty(this.name)) {
                this.controller.parameters = { name: this.name };
            }
            else {
                this.controller.parameters = { name: "" };
            }
            this.controller.filterDefinitions.modify(function (s) {
                s.remove("OrganizationType");
                if (_this.typ.organizationType != "Alle") {
                    s.add(Data.BreezeColumnFilter.contains("OrganizationType", _this.typ.organizationType));
                }
            });
            this.controller.load();
            this.attachFilterHandlers();
            this.searched = true;
            this.showAccountant = false;
        };
        IndexViewModel.prototype.getClientsOfOrganization = function (selectedOrganization) {
            this.controller.override("getclientsoforganization", { organizationId: selectedOrganization.id });
            this.controller.filterDefinitions.modify(function (s) {
                s.remove("OrganizationType");
            });
            this.controller.load();
            this.showAccountant = true;
        };
        IndexViewModel.prototype.showMembers = function (organizationToShow) {
            var params = [];
            params.push(new Navigator.NavigationParameter("organizationId", organizationToShow.id));
            params.push(new Navigator.NavigationParameter("organizationTyp", organizationToShow.organizationType));
            params.push(new Navigator.NavigationParameter("organizationUri", organizationToShow.uri));
            Navigator.navigateTo("organizationmanager", "networkmembers", "/networkmembers", null, params);
        };
        //#endregion
        //#region useractions
        IndexViewModel.prototype.changeOrganizationUri = function () {
            if (this.selectedItems().length > 0) {
                app.showDialog("areas/organizationmanager/viewmodels/changeurl", this.selectedItems()[0].id);
            }
        };
        IndexViewModel.prototype.findAndShowGatewayData = function () {
            var _this = this;
            try {
                var showUserData = new ShowUserDataCommand(this.selectedItems()[0].uri, this.selectedItems()[0].url);
                var httpClient = new HttpClient.Channel();
                httpClient.getData("/api/networkmember/byorganization?organizationId=" + this.selectedItems()[0].id, HttpClient.ServiceTarget.portalApi)
                    .then(function (data) {
                    var gatewayMember = [];
                    for (var i = 0; i < data.length; i++) {
                        gatewayMember.push(mappings.Mapper.mapNetworkMemberItemFromDTO(data[i]));
                    }
                    if (_this.selectedItems()[0].organizationType.toLowerCase() == Constants.OrganizationTypeCodes.Stb) {
                        showUserData.execute(gatewayMember.filter(function (x) { return x.loginName == "Gateway"; })[0]);
                    }
                    else if (_this.selectedItems()[0].organizationType.toLowerCase() == Constants.OrganizationTypeCodes.Client) {
                        showUserData.execute(gatewayMember.filter(function (x) { return x.memberType == Constants.NetworkMemberTypes.ClientPostmaster; })[0]);
                    }
                });
            }
            catch (exception) {
                Trace.traceError(exception.responseJSON.Message, null, "Organizationmanager", true);
            }
        };
        //#endregion
        //#region helpers
        IndexViewModel.prototype.applyOrganizationFilter = function () {
            if (!String.isNullOrEmpty(this.name)) {
                var filters = [];
                if (this.greaterThan10Members) {
                    filters.push(Data.BreezeColumnFilter.greaterThan("MemberCount", 10));
                }
                this.controller.filterDefinitions.modify(function (s) {
                    s.remove("MemberCount");
                    s.attach(filters);
                });
                this.controller.load();
            }
        };
        IndexViewModel.prototype.initialize = function (context) {
            this.detachFilterHandlers();
            var all = $.t("app:modules.common.constant_all", { ifMissing: "Alle" });
            this.typ = { organizationType: "Alle", displayName: all };
            this.setUpController(context);
            this.resendActivationCommand = new ResendActivationCommand(this.taskManager);
            this.createInfrastructureCommand = new CreateInfrastructureCommand(this.taskManager);
            this.directLoginOrgCommand = new DirectLoginOrgCommand();
            this.downloadOrgPdfCommand = new DownloadOrgPdfCommand();
            this.findAndShowGatewayDataCommand = new Commanding.DelegateCommand(this.findAndShowGatewayData, this);
            this.attachFilterHandlers();
        };
        IndexViewModel.prototype.setUpController = function (context) {
            var _this = this;
            var params;
            if (context.queryString != null) {
                params = { name: context.queryString.name };
                this.name = context.queryString.name;
                var tempType = context.queryString.searchTyp;
                if (tempType == "Alle") {
                    this.typ = this.typ = { organizationType: tempType, displayName: tempType };
                }
                else {
                    this.typ = { organizationType: tempType, displayName: Constants.OrganizationTypes.getDisplayNameForGivenOrganizationType(tempType) };
                }
            }
            else {
                params = { name: null };
            }
            if (this.controller == null) {
                this.controller = new Data.BreezeDataController(this.organizations, params).configure(function (result) { return result.map(function (s) { return mappings.Mapper.mapOrganizationItemFromDTO(s); }); });
                this.controller.sortDefinitions.modify(function (s) { return s.add(_this.controller.buildSort("Name", "desc")); });
                this.controller.override("findbynameanduri", params);
            }
        };
        IndexViewModel.prototype.attachFilterHandlers = function () {
            var _this = this;
            this.filterHandlers.push(ko.getObservable(this, "greaterThan10Members").subscribe(function () {
                _this.applyOrganizationFilter();
            }));
            this.filterHandlers.push(ko.getObservable(this, "typ").subscribe(function (_) {
                _this.getOrganizations();
            }));
        };
        IndexViewModel.prototype.detachFilterHandlers = function () {
            for (var i = this.filterHandlers.length - 1; i >= 0; i--) {
                this.filterHandlers[i].dispose();
                this.filterHandlers.pop();
            }
        };
        return IndexViewModel;
    }(organization.OrganizationBase));
    var instance = new IndexViewModel();
    return instance;
});

